import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../Assets/logo.png';

const Header = () => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const mobileMenuRef = useRef(null);
  const hamburgerButtonRef = useRef(null);

  const isActive = (path) => {
    return location.pathname === path ? 'text-blue-600 font-semibold' : 'text-gray-700 hover:text-blue-600';
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
      setPrevScrollPos(currentScrollPos);
      setIsScrolled(currentScrollPos > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuOpen && 
          mobileMenuRef.current && 
          !mobileMenuRef.current.contains(event.target) &&
          hamburgerButtonRef.current &&
          !hamburgerButtonRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    };

    if (mobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileMenuOpen]);

  return (
    <>
      <header 
        className={`bg-white shadow-sm fixed w-full z-50 transition-all duration-300 ${
          visible ? 'top-0' : '-top-20'
        } ${isScrolled ? 'shadow-md' : ''}`}
      >
        <div className="w-full mx-auto px-4 py-2 flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <img src={Logo} alt="Ascent Abacus Logo" className="h-12 w-auto" />
          </Link>
          <nav className="hidden md:flex space-x-6">
            
            <Link to="https://ascentabacus.com/"   className={`label font-medium transition-colors ${isActive('/programs')}`}>
              Our Programs
            </Link>
            <Link to="https://ascentabacus.com/about/"   className={`label font-medium transition-colors ${isActive('/about')}`}>
              About Us
            </Link>
            <Link to="https://ascentabacus.com/contact/"    className={`label font-medium transition-colors ${isActive('/contact')}`}>
              Contact Us
            </Link>
            <Link to="/login" className={`label font-medium transition-colors ${isActive('/login')}`}>
              Login/Register
            </Link>
          </nav>
          <button 
            ref={hamburgerButtonRef}
            className="md:hidden text-gray-700 focus:outline-none transition-transform duration-300"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div 
        ref={mobileMenuRef}
        className={`md:hidden fixed w-full z-40 bg-white shadow-lg overflow-hidden transition-all duration-300 ease-in-out ${
          mobileMenuOpen ? 'max-h-96' : 'max-h-0'
        }`}
        style={{ top: '4.5rem' }}
      >
        <div className="px-2 pt-2 pb-4 space-y-1">
          
          <Link 
            to="https://ascentabacus.com/" 
            className={`label block px-3 py-3 transition-all duration-200 transform ${
              mobileMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
            } ${isActive('/programs')}`}
            style={{ transitionDelay: mobileMenuOpen ? '0.2s' : '0s' }}
          >
            Our Programs
          </Link>
          <Link 
            to="https://ascentabacus.com/about/" 
            className={`label block px-3 py-3 transition-all duration-200 transform ${
              mobileMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
            } ${isActive('/about')}`}
            style={{ transitionDelay: mobileMenuOpen ? '0.3s' : '0s' }}
          >
            About Us
          </Link>
          <Link 
            to="https://ascentabacus.com/contact/" 
            className={`label block px-3 py-3 transition-all duration-200 transform ${
              mobileMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
            } ${isActive('/contact')}`}
            style={{ transitionDelay: mobileMenuOpen ? '0.4s' : '0s' }}
          >
            Contact Us
          </Link>
          <Link 
            to="/login" 
            className={`label block px-3 py-3 transition-all duration-200 transform ${
              mobileMenuOpen ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
            } ${isActive('/login')}`}
            style={{ transitionDelay: mobileMenuOpen ? '0.5s' : '0s' }}
          >
            Login/Register
          </Link>
        </div>
      </div>
    </>
  );
};

export default Header;